import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import PollDetails from './PollDetails';
import PollSuccess from './PollSuccess';

const Poll = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(poll|poll/start)"
                            name="PollDetails"
                            exact
                            component={PollDetails}
                        />
                        <Route
                            path="/poll/success"
                            name="PollSuccess"
                            exact
                            component={PollSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Poll;
